export const DEFAULT_SLOPE = 0.0;
export const DEFAULT_SURFACE_HAZARD = 2;
export const DEFAULT_NEAR_SURFACE_HAZARD = 2;
export const DEFAULT_NEAR_SURFACE_HEIGHT = 25;
export const DEFAULT_ELEVATED_HAZARD = 2;
export const DEFAULT_ELEVATED_HEIGHT = 2.0;
export const DEFAULT_BARK_HAZARD = 2;

export {DEFAULT_SUMMER_AFTERNOON_FMC} from '../shared/ffm';

export const SURFACE_FUEL_LOADS = { '4': 20, '3.5': 16, '3': 12, '2': 8, '1': 4, '0': 0 };
export const NEAR_SURFACE_FUEL_LOADS = { '4': 4, '3.5': 3.5, '3': 3, '2': 2, '1': 1, '0': 0 };
export const ELEVATED_FUEL_LOADS = { '4': 6, '3.5': 4, '3': 3, '2': 2, '1': 1, '0': 0 };
export const BARK_FUEL_LOADS = { '4': 7, '3.5': 6, '3': 5, '2': 2, '1': 1, '0': 0 };



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta/constants.js